<template>
  <svg width="16" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="6.5" stroke="#243746" stroke-width="3"/>
    <path d="M16.5 16.5C18.4526 18.4526 19.0474 19.0474 21 21" stroke="#243746" stroke-width="3" stroke-linecap="round"/>
  </svg>
</template>
